/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { Tabs } from "@cars24/turbo-web/lib/tabs";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import styles from "./styles.css";
import { LOAN_TYPE_ICONS, LOAN_TYPE_IMAGES } from "../../../constants/sf-landing-constants";
import LoanDetails from "./loan-details";
import PropTypes from "prop-types";
import { Button } from "@cars24/turbo-web/lib/button";

const TypesOfLoan = ({
    selectedLoanTypeIndex,
    content,
    images,
    forwardedRef,
    onApply
}) => {
    const { tokens } = useTokens();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedInnerIndex, setSelectedInnerIndex] = useState(0);

    const { title = "", tabs = [] } = content || {};

    useEffect(() => {
        setSelectedIndex(selectedLoanTypeIndex);
    }, [selectedLoanTypeIndex]);

    const handleTabChange = (val) => {
        setSelectedIndex(tabs.findIndex(({ id }) => id === val.id));
    };

    const getTabItems = () => {
        return tabs.map(({ id, title: loanTitle, icon, disabled }, index) => ({
            id,
            title: loanTitle,
            icon: (
                <div
                    style={{
                        WebkitMaskImage: `url(${LOAN_TYPE_ICONS[index]})`,
                        maskImage: `url(${LOAN_TYPE_ICONS[index]})`,
                        WebkitMaskSize: "contain",
                        maskSize: "contain",
                        WebkitMaskRepeat: "no-repeat",
                        maskRepeat: "no-repeat",
                        width: "16px",
                        height: "16px",
                        backgroundColor:
              index === selectedIndex
                  ? tokens.icon_brand_icon_accent
                  : tokens.icon_default_icon_primary
                    }}
                />
            ),
            disabled
        }));
    };

    return (
        <div styleName={"styles.typesOfLoanContainer"} ref={forwardedRef}>
            <div styleName={"styles.container"}>
                <div styleName={"styles.headingContainer"}>
                    <Heading
                        level={NUMBER.TWO}
                        color={tokens.text_default_text_primary}
                        isBold
                    >
                        {title || ""}
                    </Heading>
                </div>
                <div styleName={"styles.mainContainer"}>
                    <div styleName={"styles.tabsContainer"}>
                        <Tabs
                            variant="line"
                            orientation="horizontal"
                            items={getTabItems()}
                            onClick={handleTabChange}
                            defaultSelectedIndex={selectedIndex}
                        />
                    </div>
                    <div styleName={"styles.tabPanelContainer"}>
                        <LoanDetails
                            content={tabs[selectedIndex]}
                            selectedInnerIndex={selectedInnerIndex}
                            onSelectInnerIndex={setSelectedInnerIndex}
                            images={images}
                            imageSlug={LOAN_TYPE_IMAGES[selectedIndex]}
                        />
                    </div>
                    <Button
                        key={selectedIndex}
                        onClick={onApply}
                        size="large"
                        label={tabs[selectedIndex]?.cta || ""}
                    />
                </div>
            </div>
        </div>
    );
};

TypesOfLoan.propTypes = {
    selectedLoanTypeIndex: PropTypes.number,
    content: PropTypes.object,
    images: PropTypes.array,
    forwardedRef: PropTypes.object,
    onApply: PropTypes.func
};

export default TypesOfLoan;
